// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3XOlI","open":"open___yg7Kv","arrowDown":"arrowDown___12z6V"};